export const initTheme = () => {
  const theme = localStorage.getItem('theme')
  if (theme === '"dark"') {
    document.documentElement.setAttribute('data-theme', 'dark')
  }
}
